/** Extracts a Cloudinary public_id from a secure_url so a replaced asset can be cleaned up. */
export function cloudinaryPublicId(url) {
  try {
    const match = url.match(/\/image\/upload\/(?:v\d+\/)?(.+)\.[^.]+$/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}
